<!-- 底部按钮 -->
<template>
  <div class='room_footer_wrap'>
    <div class="footer_left">
      <div class="price">
        {{currency}}{{price*number*days}}
      </div>
    </div>
    <!-- <div
      class="footer_right"
      @click="wannaBookRoom"
    >确认订房</div> -->
    <van-button
      class="footer_right"
      loading-type="spinner"
      :loading="issubmit"
      :loading-text="loadtext"
      @click="wannaBookRoom"
    >{{$t('book.submitText')}}</van-button>
  </div>
</template>

<script>
import Vue from 'vue';
import { Button } from 'vant';

Vue.use(Button);
export default {
  name: 'BookFooter',
  props: {
    price: {
      type: Number,
      default: 0
    },
    number: {
      type: Number,
      default: 1
    },
    days: {
      type: Number,
      default: 1
    },
    currency: {
      type: String,
      default: '￥'
    },
    issubmit: {
      type: Boolean,
      default: false
    },
    loadtext: {
      type: String,
      default: '提交中...'
    }

  },
  data() {
    return {

    };
  },

  components: {},

  methods: {
    // 点击选择房型
    wannaBookRoom() {
      this.$emit('listenwannaBookRoom')
    }
  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.room_footer_wrap {
  position: fixed;
  width: 100%;
  bottom: 0;
  height: 60px;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  z-index: 10;
  box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.1);
  .footer_left {
    flex: 1;
    display: flex;
    .price {
      font-size: 20px;
      font-weight: 700;
      letter-spacing: 0.01em;
      color: #000;
      line-height: 40px;
    }
    .market_price {
      font-size: 12px;
      letter-spacing: 0.01em;
      color: #777;
      line-height: 48px;
      text-decoration: line-through;
    }
  }
  .footer_right {
    width: 110px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: var(--color);
    background: var(--background);
    border-radius: 4px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.01em;
  }
}
</style>